/**
 * @generated SignedSource<<fbb1f233671875144f529ed315209946>>
 * @relayHash 841a5154019e1668c168f2346349a3d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6f8b995e9fe1a9e4169c0a0204d20139cf593bee34f98e3ab1c3aa1269eb7785

import type { ConcreteRequest, Query } from 'relay-runtime';
export type src_EndOfTrialMessageSharedGlobalComponentQuery$variables = {
  cloudId: string;
  hamsProductKey: string;
};
export type src_EndOfTrialMessageSharedGlobalComponentQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly offering: {
          readonly trial?: {
            readonly lengthDays: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly preDunning: {
          readonly firstPreDunningEndTimestamp: number | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type src_EndOfTrialMessageSharedGlobalComponentQuery = {
  response: src_EndOfTrialMessageSharedGlobalComponentQuery$data;
  variables: src_EndOfTrialMessageSharedGlobalComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hamsProductKey"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "hamsProductKey"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "AND": [
        {
          "inTrialOrPreDunning": true
        }
      ]
    }
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "CcpOfferingTrial",
      "kind": "LinkedField",
      "name": "trial",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "lengthDays"
        }
      ]
    }
  ],
  "type": "CcpOffering"
},
v5 = {
  "kind": "ScalarField",
  "name": "firstPreDunningEndTimestamp"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "src_EndOfTrialMessageSharedGlobalComponentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "offering",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "preDunning",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ],
                "storageKey": "entitlement(where:{\"AND\":[{\"inTrialOrPreDunning\":true}]})"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "src_EndOfTrialMessageSharedGlobalComponentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "offering",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "preDunning",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v5/*: any*/)
                    ]
                  },
                  (v7/*: any*/)
                ],
                "storageKey": "entitlement(where:{\"AND\":[{\"inTrialOrPreDunning\":true}]})"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6f8b995e9fe1a9e4169c0a0204d20139cf593bee34f98e3ab1c3aa1269eb7785",
    "metadata": {},
    "name": "src_EndOfTrialMessageSharedGlobalComponentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2b745a126dfb19c41fa6d1eb5904c34f";

export default node;
